import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus'
import type { ConfigurableVariant } from '@pylot-data/pylotschema'

export type AvailableValues = Record<string, string[]>

/**
 * Labels de cada atributo que tienen al menos una variante comprable.
 *
 * A diferencia de `getDisabledOptionValues`, no depende de lo que este
 * seleccionado: responde "esta talla se puede comprar en alguna combinacion",
 * que es lo que necesitamos para elegir la seleccion inicial.
 *
 * Desde EVO-245 `configurable_options` incluye tambien las opciones sin stock,
 * asi que sin esto la PDP puede abrir con una talla agotada preseleccionada y
 * el boton bloqueado.
 *
 * @param variants variantes del producto configurable
 * @returns labels comprables por attribute_code, u `undefined` si no hay variantes
 */
export const getAvailableOptionValues = (
    variants?: ConfigurableVariant[] | null
): AvailableValues | undefined => {
    if (!variants?.length) return undefined

    const available: AvailableValues = {}

    // Todo atributo presente en las variantes arranca en vacio: si ninguna de sus
    // variantes tiene stock, el atributo queda sin valores seleccionables en vez de
    // caer al fallback de "no hay informacion, usar todos".
    variants.forEach((variant) => {
        variant?.attributes?.forEach((attribute) => {
            if (attribute?.code) available[attribute.code] = []
        })
    })

    variants.forEach((variant) => {
        if (variant?.product?.stock_status !== ProductStockStatus.InStock) {
            return
        }

        variant.attributes?.forEach((attribute) => {
            const code = attribute?.code
            const label = attribute?.label

            if (!code || !label) return
            if (available[code].includes(label)) return

            available[code] = [...available[code], label]
        })
    })

    return available
}
